/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Name_TitleInputs */

const en_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter Caption File Name`)
};

const fr_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisir le nom du fichier de sous-titres`)
};

const de_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie den Namen der Untertiteldatei ein`)
};

const it_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il nome del file della didascalia`)
};

const ru_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название файла с субтитрами.`)
};

const es_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca el nombre del archivo de subtítulos`)
};

const zh_cn2_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入标题文件名`)
};

const ja_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションファイル名を入力`)
};

const hi_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन फ़ाइल का नाम दर्ज करें`)
};

const pt_pt2_ateliere_connect_caption_name_title = /** @type {(inputs: Ateliere_Connect_Caption_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o nome do arquivo de legenda`)
};

/**
* | output |
* | --- |
* | "Enter Caption File Name" |
*
* @param {Ateliere_Connect_Caption_Name_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_name_title = /** @type {((inputs?: Ateliere_Connect_Caption_Name_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Name_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_caption_name_title(inputs)
	if (locale === "de") return de_ateliere_connect_caption_name_title(inputs)
	if (locale === "it") return it_ateliere_connect_caption_name_title(inputs)
	if (locale === "ru") return ru_ateliere_connect_caption_name_title(inputs)
	if (locale === "es") return es_ateliere_connect_caption_name_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_caption_name_title(inputs)
	if (locale === "ja") return ja_ateliere_connect_caption_name_title(inputs)
	if (locale === "hi") return hi_ateliere_connect_caption_name_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_caption_name_title(inputs)
	return en_ateliere_connect_caption_name_title(inputs)
});